<div
  class="flex flex-wrap items-start justify-between gap-8 bg-grey-50 px-8 py-14 text-sm lg:items-center lg:px-16 xl:px-24"
>
  <img
    ngSrc="assets/images/logo.svg"
    priority="priority"
    alt="logo"
    height="95"
    width="295"
  />
  <div>
    <p class="font-medium">OEW BREITBAND GmbH</p>
    <p>Talstrasse 21</p>
    <p>89584 Ehingen (Donau)</p>
  </div>
  <div>
    <div class="flex items-center gap-x-[5px]">
      <svg-icon class="size-4" src="assets/icons/Communication/phone.svg" />
      <a href="tel:+4973917600900" class="font-light hover:underline"
        >+49 <span class="font-medium">7391 7 600 900</span></a
      >
    </div>
    <div class="flex items-center gap-x-[5px]">
      <svg-icon class="size-4" src="assets/icons/Media_devices/printer.svg" />
      <a href="tel:+4973917600999" class="font-light hover:underline"
        >+49 <span class="font-medium">7391 7 600 999</span></a
      >
    </div>
    <div class="flex items-center gap-x-[5px]">
      <svg-icon class="size-4" src="assets/icons/Communication/mail-02.svg" />
      <a
        href="mailto:kontakt@oew-breitband.de"
        class="font-normal hover:underline"
        >{{ 'kontakt@oew-breitband.de' }}</a
      >
    </div>
  </div>
  <div>
    <p>
      <a
        href="https://www.oew-breitband.de/impressum/"
        class="hover:underline"
        target="_blank"
      >
        {{ 'footer.legalNotice' | translate }}
      </a>
    </p>
    <p>
      <a
        href="https://www.oew-breitband.de/datenschutz/"
        class="hover:underline"
        target="_blank"
      >
        {{ 'footer.privacyPolicy' | translate }}
      </a>
    </p>
  </div>
</div>
